/* Copyright © Bankers Healthcare Group, Inc.  All rights reserved. */

import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/PrivacyPolicy.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/TermsAndConditions.vue'),
  },
  {
    path: '/providers',
    name: 'providers',
    beforeEnter: () => window.location.href = process.env.VUE_APP_PROVIDERS_URL,
  },
  {
    path: '/borrowers',
    name: 'borrowers',
    beforeEnter: () => window.location.href = process.env.VUE_APP_BORROWERS_URL,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
